enum ToastType {
  BUBBLE = 'bubble',
  BANNER = 'banner'
}

export default ToastType;
